// extracted by mini-css-extract-plugin
export var chip = "_2y-9";
export var chipLabel = "_2y-a";
export var close = "_2y-7";
export var closeIcon = "_2y-8";
export var error = "_2y-6";
export var infoTooltip = "_2y-2";
export var innerContainer = "_2y-1";
export var input = "_2y-b";
export var medium = "_2y-5";
export var outerContainer = "_2y-0";
export var small = "_2y-4";
export var xSmall = "_2y-3";